module.exports = __webpack_public_path__ + "static/media/quality.a1698202.png";